
import React ,{useState}from 'react';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import {Card} from 'react-bootstrap';
import back from './img/back.png';
import firebase from "firebase/app";
import 'firebase/auth';
import 'firebase/firestore';
  function Copyright() {
    return (
      <Typography variant="body2" color="textSecondary" align="center">
        {'Copyright © '}
        <Link color="inherit" href="https://material-ui.com/">
         Porfolio Maker
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    );
    
  }

  var uid="";
  var firebaseConfig = {
    apiKey: "AIzaSyBji-cpaFoM_4bDKk7Xm39fqPPJOc1Rclo",
    authDomain: "portfolio-maker-e7976.firebaseapp.com",
    databaseURL: "https://portfolio-maker-e7976.firebaseio.com",
    projectId: "portfolio-maker-e7976",
    storageBucket: "portfolio-maker-e7976.appspot.com",
    messagingSenderId: "850245176139",
    appId: "1:850245176139:web:a37c1c74d1e85390dfb6ce",
    measurementId: "G-MY2J146SEG"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  var db = firebase.firestore();
  function afficher(){
    alert(document.getElementById("email").value);
    alert(document.getElementById("password").value);

  }
function createUser(){
  return firebase.auth().createUserWithEmailAndPassword(document.getElementById("email").value, document.getElementById("password").value)
  .then(function(result) {
    alert(result.user.uid);
    var uid=result.user.uid;
    db.collection("Users").doc(uid).set({
      first_name: document.getElementById("firstName").value,
      last_name: document.getElementById("lastName").value,
  })
  .then(function() {
      console.log("Document successfully written!");
  })
  .catch(function(error) {
      console.error("Error writing document: ", error);
  });
    // result.user.tenantId should be ‘TENANT_PROJECT_ID’.
  }).catch(function(error) {
    // Handle error.
    alert(error);
  });

}
const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(12),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  card:{
    paddingTop:10,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const SignUp = () => { 

  const classes = useStyles();
  return (
    <Container component="main" maxWidth="xs" className="cont" >
      <CssBaseline />
      <Card body className={classes.card}>
<Button icon={back}>Retour</Button>
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign up
        </Typography>
        
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="fname"
                name="firstName"
                variant="outlined"

                required
                fullWidth
                id="firstName"
                label="First Name"
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="lastName"
                label="Last Name"
                name="lastName"
                autoComplete="lname"

              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"

              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="password"

                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"

              />
            </Grid>
            <Grid item xs={12} >
              <FormControlLabel
                control={<Checkbox value="allowExtraEmails" color="primary" />}
                label="Remember me."              />
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            onClick={createUser}
            className={classes.submit}
          >
            Sign Up
          </Button>
          <Grid container justify="flex-end">
            <Grid item>
              <Link href={"/signin"} variant="body2">
                Already have an account? Sign in
              </Link>
            </Grid>
          </Grid>
       
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>
      </Card>
    </Container>
  );
};
export default SignUp;